import { apiClient } from '@/utils/apiClient';

export interface IDashboardData {
  balance: number;
  nextTopUpDate: string | null;
  monthlyUsage: number;
  monthlyLimit: number;
  monthlyResetDate: string;
}

export const fetchDashboardData = async (month?: string): Promise<IDashboardData> => {
  const { data } = await apiClient.get<IDashboardData>('/dashboard', {
    params: month ? { month } : undefined,
  });
  return data;
};
